import { useState, useCallback } from 'react'
import {
  togglePostLeaveModalEventListener,
  ToggleRichTextLeaveModalEvent
} from 'src/utils/customEvents'
import { MODAL_ACTIONS } from 'src/utils/customEvents/types'

const usePostLeaveModal = () => {
  const [isOpenLeaveModal, setIsOpenLeaveModal] = useState<boolean>(false)

  const listenerLeaveModal = useCallback(() => {
    /* istanbul ignore next */
    togglePostLeaveModalEventListener((event) => {
      const payload = (event as CustomEvent<ToggleRichTextLeaveModalEvent>).detail

      switch (payload.action) {
        case MODAL_ACTIONS.CLOSE:
          setIsOpenLeaveModal(false)
          break
        case MODAL_ACTIONS.OPEN:
          setIsOpenLeaveModal(true)
          break
      }
    })
  }, [togglePostLeaveModalEventListener])

  return {
    isOpenLeaveModal,
    setIsOpenLeaveModal,
    listenerLeaveModal
  }
}

export default usePostLeaveModal
